import './style.scss';
import { useState, useEffect } from 'react';
import {useTranslation} from "react-i18next";
import { useHistory } from "react-router-dom";
import { Redirect } from "react-router-dom"; 
import QueryService from '../../shared/queryService';
import ConfigService from '../../shared/configService';
import Utils from '../../shared/utils';
import IReport from '../../models/IReport';
import { IFeature } from '@esri/arcgis-rest-types';
import BootstrapTable from 'react-bootstrap-table-next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus} from '@fortawesome/free-solid-svg-icons';
import paginationFactory from 'react-bootstrap-table2-paginator';
import AuthService from '../../shared/authService';
import NewReport from './NewReport/NewReport';

const Reports = () => {
  
  const SIZE_PER_PAGE = 10;
  
  const history = useHistory();
  const {t} = useTranslation('reports');
  const isAdmin = window.localStorage.IUCN_ADMIN_GROUP === 'Admin' ? true : false;

  /**
   * Button formatter function
   * @param cell 
   * @param row 
   * @param rowIndex 
   * @param formatExtraData 
   * @returns 
   */
  const buttonFormatter = (cell: any, row: any, rowIndex: number, formatExtraData: any) => {
      return row.status === 'Saved' ?(
        <button className="small primary" key={rowIndex}
          onClick={() => {
            onEditClick(row);
          }}
        >
          {t('edit')}
        </button>
      ) :
      (<span></span>);
  };

  const onEditClick = (row: any) => {
    history.push(`${ConfigService.getConfig().routes?.submissionTool.editReport}?id=${row.id}`);
  }

  /**
   * Effect
   */
  useEffect(() => {
    getReportsList();
  }, []);  

  /**
   * State
   */
  const [state, setState] = useState({
      userLoaded: AuthService.checkConnectedUser(),
      showNewReport: false,
      columns: [{
          dataField: 'id',
          text: '',
          hidden: true
        }, {
          dataField: 'year',
          text: 'Reference year'
        },{
          dataField: 'zone',
          text: 'Zone'
        }, {
          dataField: 'status',
          text: 'Report status',
          classes: (cell: any, row: any, rowIndex: number, colIndex: number) => {
            return row.status.toLowerCase()
          }
        }, {
          dataField: 'edit',
          text: '',
          formatter: buttonFormatter
        }],
      reports: []
  });

  /**
   * Get reports list
   */
  const getReportsList = async () => {
      
    if(state.userLoaded) {
      const countryFilter = "reporting_entity_type = '1' OR reporting_entity_type = '' OR reporting_entity_type =null";
      const features = await QueryService.queryFeatures(Utils.getOpLayerQuery(ConfigService.getConfig().agol?.operationalLayers.reportMain.index),countryFilter, false, '*', `${ConfigService.getConfig().agol?.operationalLayers.reportMain.fields.repYear} DESC`);
      
      const reports: IReport[] = features
      .filter( (feat: IFeature) => {
        return feat.attributes[ConfigService.getConfig().agol.operationalLayers.reportMain.fields.createdUser] === AuthService.getInstance().user.username || isAdmin;
      })
      .map( (feat: IFeature) => {

        const id: number = Number(feat.attributes[ConfigService.getConfig().agol.operationalLayers.reportMain.fields.objectid]);
        const year: number = Number(feat.attributes[ConfigService.getConfig().agol.operationalLayers.reportMain.fields.repYear]);
        const name0: string = feat.attributes[ConfigService.getConfig().agol.operationalLayers.reportMain.fields.name0];
        const name1: string = feat.attributes[ConfigService.getConfig().agol.operationalLayers.reportMain.fields.name1];
        const published: boolean = feat.attributes[ConfigService.getConfig().agol.operationalLayers.reportMain.fields.published];
        const submitted: boolean = feat.attributes[ConfigService.getConfig().agol.operationalLayers.reportMain.fields.submitted];

        const zone: string = name1 ? `${name1} (State)` : `${name0} (Country)`;
        const status: any = published && submitted ? 'Published' : !published && submitted ?  'Submitted' : 'Saved';

        return {
          id: id,
          year: year,
          zone: zone,
          status: status
        }
      });
      
      Utils.setStateValue('reports', reports, state, setState);
    }
  };

  /**
   * Close form
   */
  const closeNewReport = () => {
    Utils.setStateValue('showNewReport', false, state, setState);
  }

  return state.userLoaded ?
      (
        <div className="reportsDiv">
          
          <div className="row reportsContent shadow-lg p-3 mb-5 bg-white big-border-radius">            
            <div className="row bigText">
                <span className="pageTitle">{t('title')}</span>

                <button className="createNewBtn primary" onClick={() => Utils.setStateValue('showNewReport', true, state, setState)}>
                    <span className="editSpan">{t('createNew')}</span>
                    <FontAwesomeIcon className="plusIcon" icon={ faPlus }/>
                </button>
            </div>
    
            <div>
                <BootstrapTable keyField='id' 
                data={ state.reports } 
                columns={ state.columns }
                
                pagination={ paginationFactory({sizePerPage: SIZE_PER_PAGE, hideSizePerPage: true, hidePageListOnlyOnePage: true})}/>
            </div>
          </div>
          
          {state.showNewReport && <NewReport onClose={closeNewReport}/>}
      </div>
      ):
      (<Redirect to={ConfigService.getConfig().routes?.login || ''}/>);
};

export default Reports;

